// Language options for the application
export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺' },
  { code: 'mn', name: 'Mongolian', nativeName: 'Монгол', flag: '🇲🇳' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', flag: '🇹🇭' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
];

// Define CSS class names for each accessibility setting
export const ACCESSIBILITY_CLASSES = {
  highContrast: 'accessibility-high-contrast',
  grayscale: 'accessibility-grayscale',
  invertColors: 'accessibility-invert-colors',
  highlightLinks: 'accessibility-highlight-links',
  readableFont: 'accessibility-readable-font',
  largeText: ['', 'accessibility-text-size-large', 'accessibility-text-size-extra-large'],
  lineHeight: ['', 'accessibility-line-height-tall', 'accessibility-line-height-extra-tall'],
  letterSpacing: [
    '',
    'accessibility-letter-spacing-wide',
    'accessibility-letter-spacing-extra-wide',
  ],
};

export const defaultAccessibilitySettings = {
  highContrast: false,
  grayscale: false,
  invertColors: false,
  highlightLinks: false,
  readableFont: false,
  largeText: 0,
  lineHeight: 0,
  letterSpacing: 0,
};

// Define pages that typically have a light background for header styling logic
export const LIGHT_BACKGROUND_PAGES = [
  'Providers',
  'Doctors',
  'Treatments',
  'Equipments',
  'Blog',
  'Glossary',
  'ProviderDetail',
  'DoctorDetail',
  'TreatmentDetail',
  'EquipmentDetail',
  'BlogPost',
  'BlogPostDetail',
  'MedicalProcedureDetail',
  'UserDashboard',
  'AdminDashboard',
  'PartnerDashboard',
  'PrivacyPolicy',
  'TermsConditions',
  'CookiePolicy',
  'MedicalDisclaimer',
  'AntiDiscrimination',
  'Auth',
  'ThankYou',
  'AboutUs',
  'HowItWorks',
  'MedipathsLab',
  'Subprocessors',
  'Favorites',
  'Changelog',
];

// Re-export country data from shared constants
export { countryCodes, countries } from '@/constants/countries';
